<div *ngIf="isOpen" class="multi-eligible-modal-overlay" (click)="onClose()">
  <div
    class="multi-eligible-modal-content"
    data-fs-unmask
    role="dialog"
    aria-modal="true"
    aria-labelledby="multi-eligible-modal-title"
    (click)="$event.stopPropagation()"
  >
    <header class="multi-eligible-modal-header">
      <h2 id="multi-eligible-modal-title" class="multi-eligible-modal-title">{{ modalTitle }}</h2>
      <button
        type="button"
        class="multi-eligible-modal-close"
        (click)="onClose()"
        aria-label="Close"
        [disabled]="isConfirming"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path
            d="M15 5L5 15M5 5L15 15"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </header>

    <div class="multi-eligible-modal-body">
      <!-- CWS-1426: Update Membership state replaces the chooser while open. -->
      <app-plan-change-panel
        *ngIf="showPlanChange"
        [subscriptionId]="planChangeSubscriptionId"
        [locationId]="planChangeLocationId"
        [isActive]="showPlanChange"
        (back)="onPlanChangeBack()"
        (applied)="onPlanChangeApplied($event)"
      />
      <div
        class="multi-eligible-modal-plan-change-notice"
        *ngIf="!showPlanChange && planChangeNotice"
        role="status"
      >
        <span class="multi-eligible-modal-plan-change-notice__title">{{
          planChangeNotice.title
        }}</span>
        <span>{{ planChangeNotice.body }}</span>
      </div>
      <ng-container *ngIf="!showPlanChange">
        <ng-container *ngIf="step === 'phone'">
          <label class="multi-eligible-modal-field-label" for="multi-eligible-phone-input">
            Phone number
          </label>
          <input
            id="multi-eligible-phone-input"
            class="multi-eligible-modal-input"
            type="tel"
            name="phone"
            autocomplete="tel"
            [(ngModel)]="phoneInput"
            [disabled]="isLoading || isConfirming"
            (keydown.enter)="$event.preventDefault(); onPrimaryAction()"
            placeholder="Enter customer phone"
          />
        </ng-container>

        <div class="multi-eligible-modal-history" *ngIf="canShowWashHistory">
          <app-wash-history-panel
            [isLoading]="isLoadingHistory"
            [banner]="historyBanner"
            [historyExpanded]="historyExpanded"
            [rewashEligibility]="rewashEligibility"
            [membershipRewashEligibility]="membershipRewashEligibility"
            [prepaidRewashEligibility]="prepaidRewashEligibility"
            (historyToggle)="toggleHistory()"
            (pageChange)="goToHistoryPage($event)"
            (pageSizeChange)="onHistoryPageSizeChange($event)"
            (rewashClick)="openRewashReasonModal($event)"
          />
        </div>

        <div class="multi-eligible-modal-customer-strip" *ngIf="showCustomerStrip" data-fs-unmask>
          <div class="multi-eligible-modal-customer-strip__cell">
            <span class="multi-eligible-modal-customer-strip__label">Customer name</span>
            <span class="multi-eligible-modal-customer-strip__value">{{
              customerName || '—'
            }}</span>
          </div>
          <div class="multi-eligible-modal-customer-strip__cell" *ngIf="showPlateInCustomerStrip">
            <span class="multi-eligible-modal-customer-strip__label">Vehicle license plate</span>
            <span
              class="multi-eligible-modal-customer-strip__value multi-eligible-modal-customer-strip__value--plate"
              >{{ plateNumberDisplay }}</span
            >
          </div>
          <div class="multi-eligible-modal-customer-strip__cell">
            <span class="multi-eligible-modal-customer-strip__label">Phone number</span>
            <span class="multi-eligible-modal-customer-strip__value">{{
              customerPhone || '—'
            }}</span>
          </div>
        </div>

        <section class="multi-eligible-modal-section" *ngIf="showVehicleChooser">
          <p class="multi-eligible-modal-chooser-label">Choose Vehicle</p>
          <div
            class="multi-eligible-modal-cards multi-eligible-modal-cards--row"
            role="radiogroup"
            aria-label="Vehicle"
          >
            <button
              type="button"
              class="multi-eligible-modal-card"
              *ngFor="let card of vehicleCards; trackBy: trackByVehicleId"
              role="radio"
              [attr.aria-checked]="selectedVehicleId === card.id"
              [class.multi-eligible-modal-card--selected]="selectedVehicleId === card.id"
              [disabled]="isConfirming || isLoading"
              (click)="onSelectVehicle(card)"
            >
              <span class="multi-eligible-modal-card__radio" aria-hidden="true"></span>
              <span class="multi-eligible-modal-card__content">
                <span class="multi-eligible-modal-card__name">{{ card.licensePlate }}</span>
                <span class="multi-eligible-modal-card__meta">{{ card.detailLine }}</span>
                <span class="multi-eligible-modal-card__meta" *ngIf="card.resumesOnDisplay"
                  >Resumes on: {{ card.resumesOnDisplay }}</span
                >
              </span>
            </button>
          </div>
        </section>

        <section class="multi-eligible-modal-section" *ngIf="showPackageChooser">
          <p class="multi-eligible-modal-chooser-label">{{ packageChooserLabel }}</p>

          <ng-container *ngIf="showPackageCategories; else flatPackageCards">
            <div
              class="multi-eligible-modal-category"
              *ngFor="let category of cardCategories; trackBy: trackByCategoryKey"
            >
              <p class="multi-eligible-modal-category__label">{{ category.label }}</p>
              <div
                class="multi-eligible-modal-cards multi-eligible-modal-cards--row"
                role="radiogroup"
                [attr.aria-label]="category.label"
              >
                <button
                  type="button"
                  class="multi-eligible-modal-card"
                  *ngFor="let card of category.cards; trackBy: trackByCardId"
                  role="radio"
                  [attr.aria-checked]="selectedCardId === card.id"
                  [class.multi-eligible-modal-card--selected]="selectedCardId === card.id"
                  [disabled]="isConfirming || isLoading || prepaidStatusLoading"
                  (click)="onSelectCard(card)"
                >
                  <span
                    class="family-tag family-tag--label multi-eligible-modal-card__family-label"
                    data-testid="family-label"
                    *ngIf="card.isFamily"
                    >{{ familyTagLabel }}</span
                  >
                  <span class="multi-eligible-modal-card__radio" aria-hidden="true"></span>
                  <span class="multi-eligible-modal-card__content">
                    <span class="multi-eligible-modal-card__title-row">
                      <span class="multi-eligible-modal-card__name">{{ card.packageName }}</span>
                      <span
                        class="family-tag"
                        data-testid="family-primary"
                        *ngIf="card.isPrimary"
                        >{{ familyPrimaryLabel }}</span
                      >
                      <span
                        class="multi-eligible-modal-card__badge"
                        [class.multi-eligible-modal-card__badge--paused]="!!card.statusTag"
                        >{{ card.statusLabel }}</span
                      >
                    </span>
                    <span
                      class="multi-eligible-modal-card__meta multi-eligible-modal-card__customer"
                      *ngIf="card.customerName"
                      >{{ card.customerName }}</span
                    >
                    <span class="multi-eligible-modal-card__meta">{{ card.detailLine }}</span>
                    <span class="multi-eligible-modal-card__meta" *ngIf="card.resumesOnDisplay"
                      >Resumes on: {{ card.resumesOnDisplay }}</span
                    >
                    <span
                      class="multi-eligible-modal-card__meta multi-eligible-modal-card__card-on-file"
                      data-testid="card-on-file"
                      *ngIf="selectedCardId === card.id && selectedCardOnFile"
                      >Card on file · {{ selectedCardOnFile }}</span
                    >
                  </span>
                </button>
              </div>
            </div>
          </ng-container>

          <ng-template #flatPackageCards>
            <div
              class="multi-eligible-modal-cards multi-eligible-modal-cards--row"
              role="radiogroup"
              [attr.aria-label]="packageChooserLabel"
            >
              <button
                type="button"
                class="multi-eligible-modal-card"
                *ngFor="let card of cards; trackBy: trackByCardId"
                role="radio"
                [attr.aria-checked]="selectedCardId === card.id"
                [class.multi-eligible-modal-card--selected]="selectedCardId === card.id"
                [disabled]="isConfirming || isLoading || prepaidStatusLoading"
                (click)="onSelectCard(card)"
              >
                <span
                  class="family-tag family-tag--label multi-eligible-modal-card__family-label"
                  data-testid="family-label"
                  *ngIf="card.isFamily"
                  >{{ familyTagLabel }}</span
                >
                <span class="multi-eligible-modal-card__radio" aria-hidden="true"></span>
                <span class="multi-eligible-modal-card__content">
                  <span class="multi-eligible-modal-card__title-row">
                    <span class="multi-eligible-modal-card__name">{{ card.packageName }}</span>
                    <span class="family-tag" data-testid="family-primary" *ngIf="card.isPrimary">{{
                      familyPrimaryLabel
                    }}</span>
                    <span
                      class="multi-eligible-modal-card__badge"
                      [class.multi-eligible-modal-card__badge--paused]="!!card.statusTag"
                      >{{ card.statusLabel }}</span
                    >
                  </span>
                  <span
                    class="multi-eligible-modal-card__meta multi-eligible-modal-card__customer"
                    *ngIf="card.customerName"
                    >{{ card.customerName }}</span
                  >
                  <span class="multi-eligible-modal-card__meta">{{ card.detailLine }}</span>
                  <span class="multi-eligible-modal-card__meta" *ngIf="card.resumesOnDisplay"
                    >Resumes on: {{ card.resumesOnDisplay }}</span
                  >
                  <span
                    class="multi-eligible-modal-card__meta multi-eligible-modal-card__card-on-file"
                    data-testid="card-on-file"
                    *ngIf="selectedCardId === card.id && selectedCardOnFile"
                    >Card on file · {{ selectedCardOnFile }}</span
                  >
                </span>
              </button>
            </div>
          </ng-template>

          <p *ngIf="cards.length === 0" class="multi-eligible-modal-empty">
            <ng-container *ngIf="rewashChoiceRequired; else noEligibleOptions">
              No redeemable purchases — use wash history to grant a rewash if eligible.
            </ng-container>
            <ng-template #noEligibleOptions>No eligible options found for this plate.</ng-template>
          </p>
        </section>

        <section class="multi-eligible-modal-prepaid" *ngIf="showPrepaidExpand" data-fs-unmask>
          <div class="multi-eligible-modal-prepaid__header">
            <span class="multi-eligible-modal-prepaid__eyebrow">Prepaid (Active)</span>
            <div class="multi-eligible-modal-prepaid__title-row">
              <span class="multi-eligible-modal-prepaid__title">{{ prepaidWashbookTitle }}</span>
              <span class="multi-eligible-modal-card__badge">Active</span>
            </div>
          </div>

          <div
            class="multi-eligible-modal-prepaid__loading"
            *ngIf="prepaidStatusLoading"
            aria-busy="true"
          >
            <span class="multi-eligible-modal-prepaid__shimmer"></span>
            <span class="multi-eligible-modal-prepaid__shimmer"></span>
          </div>

          <div
            class="multi-eligible-modal-prepaid__error"
            *ngIf="prepaidStatusError && !prepaidStatusLoading"
            role="alert"
          >
            <p>{{ prepaidStatusError }}</p>
            <button
              type="button"
              class="multi-eligible-modal-prepaid__retry"
              (click)="onRetryPrepaidStatus()"
            >
              Try again
            </button>
          </div>

          <ng-container *ngIf="prepaidStatus && !prepaidStatusLoading">
            <div
              class="multi-eligible-modal-prepaid__summary"
              *ngIf="prepaidSummaryCards.length > 0"
            >
              <div
                class="multi-eligible-modal-prepaid__summary-card"
                *ngFor="let card of prepaidSummaryCards; trackBy: trackBySummaryCardId"
              >
                <span class="multi-eligible-modal-prepaid__summary-type">{{
                  card.washTypeLabel
                }}</span>
                <span class="multi-eligible-modal-prepaid__summary-remaining"
                  >{{ card.remaining }}/{{ card.limit }} remaining</span
                >
                <span class="multi-eligible-modal-prepaid__summary-name">{{
                  card.packageLabel
                }}</span>
                <span class="multi-eligible-modal-prepaid__summary-dates" *ngIf="card.dateLine">{{
                  card.dateLine
                }}</span>
              </div>
            </div>

            <!-- CWS-1915: the wash is picked on Redeem Prepaid Purchase, which this book continues to. -->
          </ng-container>
        </section>
        <app-subscription-pause-notice
          *ngIf="pauseView?.banner"
          [pause]="selectedOption?.pause ?? null"
        />
      </ng-container>
    </div>

    <footer class="multi-eligible-modal-footer" *ngIf="!showPlanChange">
      <p *ngIf="confirmError" class="multi-eligible-modal-error" role="alert">{{ confirmError }}</p>
      <div
        class="multi-eligible-modal-footer__actions"
        [class.multi-eligible-modal-footer__actions--split]="showManageMenu"
      >
        <!-- CWS-1426 / CWS-1547 / CWS-1536: Manage Subscription menu for the selected Way membership. -->
        <app-manage-subscription-menu
          *ngIf="showManageMenu"
          [showUpdate]="pauseView ? pauseView.manage.updateVisible : canChangePlan"
          [showPause]="pauseView ? pauseView.manage.pauseVisible : false"
          [showCancelScheduled]="pauseView?.manage?.showCancelScheduled ?? false"
          [showPaymentMethod]="showPaymentMethod"
          [showStartFamily]="showStartFamilyItem"
          (startFamily)="onManageStartFamily()"
          (update)="onManageUpdate()"
          (pause)="onManagePause()"
          (cancelScheduledPause)="onManageCancelScheduledPause()"
          (paymentMethod)="onManagePaymentMethod()"
        />
        <div class="multi-eligible-modal-footer__primary-group">
          <button
            type="button"
            class="btn btn-secondary btn-large"
            *ngIf="showBackButton"
            [disabled]="isConfirming || isLoading"
            (click)="onBack()"
          >
            Back
          </button>
          <button
            *ngIf="showActivate"
            type="button"
            class="btn btn-primary-green btn-large multi-eligible-modal-redeem"
            data-testid="activate-now"
            [disabled]="pauseFlow.busy"
            (click)="onActivateNow()"
          >
            {{ pauseFlow.busy ? 'Activating...' : 'Activate now' }}
          </button>
          <button
            *ngIf="!showActivate"
            type="button"
            class="btn btn-primary btn-large multi-eligible-modal-redeem"
            [disabled]="!canSubmitPrimary"
            (click)="onPrimaryAction()"
          >
            {{ primaryButtonLabel }}
          </button>
        </div>
      </div>
    </footer>
  </div>
</div>

<app-rewash-reason-modal
  *ngIf="isOpen"
  [isOpen]="rewashReasonModalOpen"
  [originalOrderId]="rewashTarget?.originalOrderId ?? null"
  [originalSubscriptionWashId]="rewashTarget?.originalSubscriptionWashId ?? null"
  [originalPrepaidRedemptionId]="rewashTarget?.originalPrepaidRedemptionId ?? null"
  [laneId]="rewashLaneId"
  (closed)="closeRewashReasonModal()"
  (confirmed)="onRewashConfirmed($event)"
></app-rewash-reason-modal>

<app-pause-subscription-modal
  [visible]="!!pauseFlow.pauseTarget"
  [periodEnd]="pauseFlow.pauseTarget?.periodEnd ?? null"
  [timeZone]="pauseFlow.pauseTarget?.timeZone ?? null"
  [busy]="pauseFlow.busy"
  [errorCode]="pauseFlow.errorCode"
  (selectionChange)="pauseFlow.clearError()"
  (confirm)="pauseFlow.confirmPause($event)"
  (cancel)="pauseFlow.closePause()"
/>

<app-confirm-action-modal
  *ngIf="pauseFlow.cancelTarget"
  title="Cancel scheduled pause?"
  message="The membership will stay active and keep billing as normal."
  confirmLabel="Cancel pause"
  cancelLabel="Keep pause"
  busyLabel="Cancelling..."
  [busy]="pauseFlow.busy"
  testId="cancel-scheduled-pause-modal"
  style="--confirm-modal-overlay-z: 13000"
  (confirm)="pauseFlow.confirmCancelScheduled()"
  (cancel)="pauseFlow.dismissCancelScheduled()"
>
  <p class="multi-eligible-modal-error" *ngIf="flowError" role="alert">{{ flowError }}</p>
</app-confirm-action-modal>

<app-confirm-action-modal
  *ngIf="pauseFlow.activateTarget"
  title="Activate now?"
  [message]="activateMessage"
  confirmLabel="Activate now"
  busyLabel="Activating..."
  [busy]="pauseFlow.busy"
  testId="activate-now-modal"
  style="--confirm-modal-overlay-z: 13000"
  (confirm)="pauseFlow.confirmActivate()"
  (cancel)="pauseFlow.dismissActivate()"
>
  <p class="multi-eligible-modal-error" *ngIf="flowError" role="alert">{{ flowError }}</p>
</app-confirm-action-modal>

<app-subscription-result-modal
  [visible]="!!pauseFlow.result"
  [header]="pauseFlow.result?.header ?? ''"
  [title]="pauseFlow.result?.title ?? ''"
  [message]="pauseFlow.result?.message ?? ''"
  (close)="pauseFlow.closeResult()"
/>

<!-- CWS-1581: Start Family pop-up and its result, over this one. -->
<app-start-family-modal
  [target]="startFamilyFlow.target"
  [preview]="startFamilyFlow.preview"
  [loading]="startFamilyFlow.loading"
  [busy]="startFamilyFlow.busy"
  [reason]="startFamilyFlow.reason"
  (confirm)="startFamilyFlow.confirm()"
  (cancel)="startFamilyFlow.close()"
/>

<app-family-members-modal [flow]="membersFlow" />

<!-- CWS-1536: the Subscriptions tab's Payment method pop-up, over this one. -->
<app-payment-method-modal
  *ngIf="paymentMethodSubject as subject"
  [subject]="subject"
  (updated)="onPaymentMethodUpdated($event)"
  (closed)="closePaymentMethod()"
/>
